import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
const TokenValidation = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('attention')} !</h4>
            <p> {props.t('please_login_to_launch_the_game_lobby')}</p>
            <p> {props.t('thank_you')}.</p>
        </div>
    )
}

TokenValidation.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(TokenValidation);